<template>
        <b-modal id="editSalaryRowModal" :title="salaryRow.id ? 'Ändra löneartrad' : 'Ny löneartrad'" v-if="salaryRow">
            <div class="form-group">
                <multiselect 
                    v-model="selectedDefinition"
                    v-if="definitions" 
                    :options="definitions" 
                    :custom-label="salaryRowWithId" 
                    selectLabel="Tryck enter för att välja"
                    selectedLabel="Vald"
                    @select="definitionSelected"
                    placeholder="Välj löneart" label="name" track-by="id"/>
            </div>
            <div class="form-group">
                <input type="text"
                    v-model="salaryRow.comment"
                    placeholder="Kommentar"
                    class="form-control" />
            </div>
            <div class="form-group">
                <input :value="salaryRow.startDate | moment('YYYY-MM-DD')"
                 type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="Fråndatum"
                                @input="salaryRow.startDate = $event.target.valueAsDate" 
                                 class="form-control" style="width:150px" >
            </div>
            <div class="form-group">
                <input  :value="salaryRow.endDate | moment('YYYY-MM-DD')"
                 type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="Tilldatum"
                                @input="salaryRow.endDate = $event.target.valueAsDate" 
                                 class="form-control" style="width:150px" >
            </div>
            <div class="form-group">
                <input type="number"
                    v-model.number="salaryRow.quantity"
                    placeholder="Antal"
                    min="1"
                    max="100"
                    class="form-control" style="width:120px"  />
            </div>
            <div class="form-group">
                <b-dropdown :text="selectedUnit ? selectedUnit.name : 'Välj enhet'">
                    <b-dropdown-item v-for="unit in units" :key="unit.id" v-on:click="unitSelected(unit)">{{unit.name}}</b-dropdown-item>
                </b-dropdown>
            </div>
            <div class="form-group">
                <input type="number"
                    v-model.number="salaryRow.pricePerUnit"
                    placeholder="Á-pris"
                    min="0"
                    style="width:120px" 
                    class="form-control" />
            </div>
            <div class="form-group">
                <input type="number"
                    v-model.number="salaryRow.sum"
                    placeholder="Belopp "
                    style="width:120px" 
                    class="form-control" />
            </div>
            <template slot="modal-footer" slot-scope="{ ok, cancel }">
                <b-button @click="cancel()">Avbryt</b-button>
                <b-button variant="primary" :disabled="saving || !salaryRow.definition"  @click="okButtonPressed()">
                <b-spinner v-if="saving" class="mr-1" type="border" small />{{saving ? "Sparar" : "Spara" }}
                </b-button>
            </template>
        </b-modal>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { salarySpecificationService } from "../../../shared/services";
import { fail } from 'assert';

export default {
    components: {
        Multiselect,
    },
    computed: {
        selectedUnit() {
            return this.units.filter(s => { return s.id === this.salaryRow.unit;})[0];
        }
    },
    data() {
        return {
            units: [
                { id: 1, name: "Timmar" },
                { id: 2, name: "Dagar" },
                { id: 3, name: "Kronor" },
                { id: 4, name: "Mil" },
                { id: 5, name: "Kalenderdagar" }
            ],
            definitions: null,
            selectedDefinition: null,
            selectedStartDate: String,
            selectedEndDate: String,
            loading:false,
            saving:false
        };
    },    
    props: {
        salarySpecificationId: null,
        salaryRow: null,
    },
    methods: {
        okButtonPressed() {
            this.saving = true;
            salarySpecificationService.saveSalaryRow(this.salarySpecificationId, this.salaryRow).then(p => {
                this.saving = false;
                this.$bvModal.hide('editSalaryRowModal');
                this.ShowToast("Sparad", "Löneraden sparades", "success");
                this.$emit("onSalaryRowSaved", p);
            }).catch(() => {
                this.saving = false;
                this.ShowToast("Fel", "Ett okänt fel uppstod då löneraden skulle sparas", "danger");
            });
        },
        show() {
            this.selectedDefinition = null;
            this.getAllDefinitions();
        },
        getAllDefinitions() {
            this.$emit("onLoading", true); 
            salarySpecificationService.getDefinitions().then(p => {
                this.definitions = p;
                this.$emit("onLoading", false); 

                if(this.salaryRow.definitionId) this.selectedDefinition = p.filter(p => p.id === this.salaryRow.definitionId)[0];
                this.$bvModal.show('editSalaryRowModal');
            }).catch(() => {
                this.ShowToast("Fel", "Ett okänt fel uppstod då definitioner skulle hämtas", "danger");
                this.$emit("onLoading", false); 
            })
        },
        salaryRowWithId ({ id, name }) {
            return `${id} — ${name}`
        },
        definitionSelected(definition) {
            this.salaryRow.definition = definition.name;
            this.salaryRow.definitionId = definition.id;
        },
        unitSelected(unit) {
            this.salaryRow.unit = unit.id;
        },
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>


</style>
